import { withInstall } from '@tav-ui/utils/with-install'
import FilePreview from './index.vue'

export * from './types'
export const TaFilePreview = withInstall(FilePreview)
export default TaFilePreview
